module.exports = __webpack_public_path__ + "img/icon-white.e1a6b5c0.png";